export default "__VITE_ASSET__D8X76zor__"